"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
var _magnet = _interopRequireDefault(require("./magnet"));
exports.magnetFonts = _magnet.default;
var _hthgo = _interopRequireDefault(require("./hthgo"));
exports.hthgoFonts = _hthgo.default;
var _hth = _interopRequireDefault(require("./hth"));
exports.hthFonts = _hth.default;
var _keittiomaailma = _interopRequireDefault(require("./keittiomaailma"));
exports.keittiomaailmaFonts = _keittiomaailma.default;
var _norema = _interopRequireDefault(require("./norema"));
exports.noremaFonts = _norema.default;
var _marbodal = _interopRequireDefault(require("./marbodal"));
exports.marbodalFonts = _marbodal.default;
var _ewe = _interopRequireDefault(require("./ewe"));
exports.eweFonts = _ewe.default;
var _invita = _interopRequireDefault(require("./invita"));
exports.invitaFonts = _invita.default;
var _intuo = _interopRequireDefault(require("./intuo"));
exports.intuoFonts = _intuo.default;
var _novart = _interopRequireDefault(require("./novart"));
exports.novartFonts = _novart.default;